<template>
  <div class="backgroundColorLightGrey">
    <div class="container">
      <div class="row flexBoxSpreadCenteredColumn signInPage textCenter">
        <a href="/">
          <img
            class="signInLogo paddingLarge"
            src="/images/dark-logo.svg"
            alt="Leland Little Auctions"
          >
        </a>

        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="authenticated"
            :key="'signing_out'"
          >
            <div class="majorTitle">
              Signing out...
            </div>
            <div class="paddingLargeLeft paddingLargeRight paddingLargeBottom marginNormalBottom">
              Please wait while we sign you out of your Leland Little account.
            </div>
          </div>

          <div
            v-else
            :key="'signed_out'"
          >
            <div class="majorTitle">
              You have been signed out.
            </div>
            <div class="paddingLargeLeft paddingLargeRight paddingLargeBottom marginNormalBottom">
              You have been signed out of your Leland Little account.
            </div>
            <div class="row">
              <div class="twelve columns">
                <a
                  href="/"
                  class="button bidButton backgroundColorDefault u-full-width"
                >Continue</a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'SignOutCard',
	data () {
		return {}
	},
	computed: {
		authenticated: function () {
			return this.$store.getters.isAuthenticated
		}
	},
	mounted () {
		this.$store.dispatch('logout')
	}
}

</script>

<style scoped>
</style>

<style scoped>

</style>
